<script setup lang="ts">
import { computed, type PropType } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAuth } from '@/entities/Auth'
import type { ObjectTypeTypeShort } from '@/entities/Manuals/ObjectTypes'

const props = defineProps({
  type: {
    type: Object as PropType<ObjectTypeTypeShort>,
    required: true,
  },
})

const route = useRoute()
const router = useRouter()
const auth = useAuth()

/* Доступ к разделу конфигурации — ссылку на тип показываем только при наличии права */
const canOpenTypeConfig = computed(() => auth.isTab('ADMIN'))

/** Ссылка на редактирование каталожного типа в конфигураторе */
const typeConfigLink = computed(() =>
  router.resolve({
    name: 'objects.groups.admin.config',
    params: {
      type: 'groups',
      object_id: route.params.object_id,
      tab: 'admin',
      section: 'config',
      list: 'object-types',
      action: 'edit',
      entity_id: props.type.id,
    },
  }),
)
</script>

<template>
  <VChip
    v-if="canOpenTypeConfig"
    class="object-type-card__chip"
    :to="typeConfigLink"
    target="_blank"
    size="x-small"
    variant="tonal"
    color="primary"
    label
    @click.stop
  >
    {{ type.id }} {{ type.name }}
  </VChip>
  <span v-else class="object-type-card__type">• {{ type.id }} {{ type.name }}</span>
</template>
